import type { PaymentMethodEnum } from "@/generated/graphql";
import {
  DEFAULT_PAYMENT_METHOD_ID,
  type StorablePaymentMethodId,
} from "@/lib/paymentMethods";

const PAYMENT_METHOD_TO_GQL: Record<StorablePaymentMethodId, PaymentMethodEnum> = {
  money: "MONEY",
  credit_card: "CREDIT_CARD",
};

const PAYMENT_METHOD_FROM_GQL: Record<PaymentMethodEnum, StorablePaymentMethodId> = {
  MONEY: "money",
  CREDIT_CARD: "credit_card",
};

export function paymentMethodIdsFromGraphql(
  values: readonly PaymentMethodEnum[] | null | undefined
): StorablePaymentMethodId[] {
  if (!values || values.length === 0) {
    return [DEFAULT_PAYMENT_METHOD_ID];
  }

  return values.map((value) => PAYMENT_METHOD_FROM_GQL[value]);
}

export function paymentMethodIdsToGraphql(ids: readonly StorablePaymentMethodId[]): PaymentMethodEnum[] {
  return ids.map((id) => PAYMENT_METHOD_TO_GQL[id]);
}
